import ScreenRotate from 'app/display/ui/ScreenRotate';

export default class AspectController {
  constructor(game, activate) {
    this.game = game;
    this.rotateScreen = false;
  }

  gameIsRotated() {
    return this.game.width <= this.game.height;
  }

  isRotated() {
    return this.rotateScreen && this.rotateScreen.screenActive;
  }

  updateGameSize() {
    if (this.game.scale) {
      let targetHeight = this.game.deviceController.requireBrimPadding()
        ? window.innerHeight - this.game.deviceController.brimPadding
        : window.innerHeight;
      let aspect = window.innerWidth / targetHeight;
      let targetWidth = this.game.defaultHeight * aspect;

      /*
      if (this.game.deviceController.requireBrimPadding()) {
        document.getElementById('game_container').style.height =
          'calc(100% - ' + this.game.deviceController.brimPadding + 'px)';
        document.body.style.background = '#000000';
      } else {
        document.getElementById('game_container').style.height = '100%';
      }
      */

      /**
       * https://github.com/bbc/cbbc-horrible-histories-gruesome-game-a-thon/issues/41
       * White line on left on Samsung S8, reproduced with odd numbered width or height
       */
      targetWidth = targetWidth % 2 != 0 ? targetWidth + 1 : targetWidth;

      this.game.screenPadding = Math.max(targetWidth, this.game.defaultHeight) * 0.02;
      this.game.screenPaddingX = this.game.screenPadding;
      this.game.screenPaddingY = this.game.screenPaddingY;
      this.game.scale.setGameSize(targetWidth, this.game.defaultHeight);
      this.game.scale.setUserScale(targetHeight / this.game.defaultHeight);
      this.game.offsetWidth = this.game.width / 2 - this.game.defaultWidth / 2;
      this.game.offsetHeight = this.game.height / 2 - this.game.defaultHeight / 2;
      this.game.aspectScale = Math.max(1, this.game.width / this.game.defaultWidth);

      // the designs cap the screen hugging at 16/9, so we account for the extra
      let wideScreenPadding = 0;
      if (this.game.scale.aspectRatio > 17 / 9) {
        wideScreenPadding = (this.game.height / this.game.scale.aspectRatio) * 0.5;
      }

      this.game.screenPaddingX += wideScreenPadding;

      if (this.game.hud) {
        if (!this.rotateScreen) {
          this.rotateScreen = new ScreenRotate(this.game);
          this.rotateScreen.activateScreen(this.game);
          this.rotateScreen.deactivateScreen(this.game);
        }

        if (this.game.width <= this.game.height && !this.isRotated()) {
          this.rotateScreen.activateScreen(this.game);
        } else if (this.game.width > this.game.height && this.isRotated()) {
          this.rotateScreen.deactivateScreen(this.game);
        } else if (this.isRotated()) {
          this.rotateScreen.positionContainer(this.game);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/AspectController.js